export const PERMISSION_PATH = 'CampaignReport';
export const PAGE_TITLE = 'Quản lý số liệu chiến dịch';
export const EXPORT_FILENAME = 'BAOCAOCHIENDICH';
